import { useQueryClient, useQuery } from '@tanstack/react-query';
import { Target, RotateCw } from 'lucide-react';
import { apiClient } from '@/lib/api-client';
import { cn } from '@/lib/utils';

/**
 * Big number: contagem de tarefas pendentes.
 * Lê o total da resposta paginada com pageSize=1 (economiza bandwidth).
 * Botão refresh reinvalida a query.
 */
export function ProductivityWidget() {
  const queryClient = useQueryClient();

  const { data, isLoading, isFetching } = useQuery({
    queryKey: ['tasks', 'list', { page: 1, pageSize: 1, status: 'pending' }],
    queryFn: () =>
      apiClient.tasksList({ page: 1, pageSize: 1, status: 'pending' }),
    staleTime: 1000 * 60,
  });

  const total = data?.total ?? 0;

  return (
    <div
      className={cn(
        'flex h-full flex-col overflow-hidden rounded-xl border shadow-[var(--shadow-card)] backdrop-blur-[var(--blur)]',
        'border-[var(--card-border)] bg-[var(--card-bg)] text-[var(--fg)]',
      )}
    >
      {/* Header */}
      <div className="flex h-12 shrink-0 items-center gap-2 border-b border-[var(--border)] px-4">
        <Target className="h-4 w-4 text-[var(--fg-muted)]" />
        <h3 className="flex-1 text-sm font-medium tracking-tight">Produtividade</h3>
        <button
          type="button"
          onClick={() =>
            void queryClient.invalidateQueries({
              queryKey: ['tasks', 'list', { page: 1, pageSize: 1, status: 'pending' }],
            })
          }
          aria-label="Atualizar"
          className="flex h-6 w-6 items-center justify-center rounded text-[var(--fg-muted)] hover:bg-[color-mix(in_oklch,var(--fg)_8%,transparent)] hover:text-[var(--fg)] transition"
        >
          <RotateCw className={cn('h-3.5 w-3.5', isFetching && 'animate-spin')} />
        </button>
      </div>

      {/* Body */}
      <div className="flex flex-1 flex-col items-center justify-center gap-1 p-4">
        {isLoading ? (
          <div className="h-16 w-20 animate-pulse rounded bg-[var(--surface-muted)]" />
        ) : (
          <>
            <span className="text-5xl font-bold tabular-nums text-[var(--fg)]">
              {total}
            </span>
            <span className="text-xs text-[var(--fg-muted)]">Tarefas pendentes</span>
          </>
        )}
      </div>
    </div>
  );
}
